module.exports = __webpack_public_path__ + "static/bgHeroGarantia-3c1951e8f75e1ab82c42bcd1d6945910.jpg";